import React, { FC, ReactNode } from 'react';
import Dropzone, { DropzoneProps } from 'react-dropzone';

import Box from '@mui/material/Box';
import { themeColor } from 'lib';

type Props = { icon: ReactNode; text?: string } & DropzoneProps;

const DropZone: FC<Props> = props => {
  const {
    icon,
    text = 'Tempkite failą arba spauskite čia, kad pradėti įkėlimą.',
    ...rest
  } = props;

  return (
    <Dropzone {...rest}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <Box
          {...getRootProps()}
          sx={theme => {
            const styles = {
              borderStyle: 'dashed',
              color: themeColor(theme, 'secondary'),
              width: '100%',
              textAlign: 'center',
              paddingTop: 1,
              paddingBottom: 1,
              marginBottom: 1,
            } as const;

            if (isDragActive) {
              return {
                ...styles,
                borderColor: themeColor(theme, 'success'),
                color: themeColor(theme, 'success'),
                backgroundColor: 'rgba(76, 175, 80, 0.2)',
              };
            }

            return styles;
          }}>
          <input {...getInputProps()} />

          {icon}

          {isDragActive ? <p>Pradėti įkėlimą...</p> : <p>{text}</p>}
        </Box>
      )}
    </Dropzone>
  );
};

export default DropZone;
